import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import EventBus from "../utils/EventBus";
import productService from "../services/product.service";
import countryService from "../services/country.service";

export const getcountries = createAsyncThunk(
  "api/getcountries",
  async (thunkAPI) => {
    try {
      const data = await countryService.getCountries();
      return { productdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getstates = createAsyncThunk(
  "api/getstates",
  async (country, thunkAPI) => {
    try {
      const data = await countryService.getStatesByCountry(country);
      return { productdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getcities = createAsyncThunk(
  "api/getcities",
  async (paydata, thunkAPI) => {
    try {
      const data = await countryService.getCitiesByCountry(paydata);
      return { productdata: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
        console.log(error.response.status);
        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState ={
    countries: [],
    staties:[],
    cities:[]
}

const countrySlice = createSlice({
  name: "api",
  initialState,
  extraReducers: {
    [getcountries.fulfilled]: (state, action) => {
    state.countries = action.payload.productdata.data
    return state;
  },
  [getstates.fulfilled]: (state, action) => {
    state.staties = action.payload.productdata.data.states
    return state;
  },
  [getcities.fulfilled]: (state, action) => {
    state.cities = action.payload.productdata.data
    return state;
  }
  },
});

const { reducer } = countrySlice;
export default reducer;